query getLeadSuggestions($input: GetLeadSuggestionsInput!) {
  leads: getLeadSuggestions(input: $input) {
    id
    email
    firstname
    lastname
  }
}
